// extracted by mini-css-extract-plugin
export default {"title":"Quote_title__NcPPm","edit":"Quote_edit__ddlL7","total":"Quote_total__QxZyS"};